__webpack_require__.p = "/crypto-info-app/";